import { getMetaData } from 'common/header/notifications/hooks/mappers/impl/shared';
import { type MappedNotification, type NotificationMapper } from 'common/header/notifications/Notifications.types';

export const workflowNotificationMapper: NotificationMapper = (notification, options) => {
  const metadata = getMetaData(notification);

  let goTo =
    notification.resourceUid?.[0] === 'K' ? `/${options.tenantCode}/tasks/${notification.resourceUid}` : undefined;
  const personUid = getMetaData(notification).value('targetPersonUid');
  const workerQualificationUid = getMetaData(notification).value('targetWorkerQualificationUid');

  if (checkIsWorkerQualificationType(notification) && !!personUid && !!workerQualificationUid) {
    goTo = goToEligibilityProvisioningPage(personUid, workerQualificationUid, options.tenantCode);
  }
  return {
    ...notification,
    title: metadata.value('SUBJECT') ?? '',
    description: metadata.value('BODY') ?? '',
    to: goTo
  };
};

export function checkIsWorkerQualificationType(notification: MappedNotification): boolean {
  return notification.type === 'WORKFLOW_NOTIFICATION';
}

function goToEligibilityProvisioningPage(personUid: string, workerQualificationUid: string, tenantCode: string) {
  return `/${tenantCode}/profile/${personUid}/eligibility-and-provisioning?requirementUid=${workerQualificationUid}`;
}
